import {createSlice} from '@reduxjs/toolkit'
import hit from 'src/services/manager'
import { setToast } from 'src/redux/toast'

const initialState={
    list:[]
}

const supportSlice=createSlice({
    name:"support",
    initialState,
    reducers:{
        setSupportList:(state,action)=>{
            state.list=action.payload
        }
    }
})

export const {setSupportList}=supportSlice.actions

export const getSupportsThunk=()=>{
    return async(dispatch)=>{
        try{
            let res=await hit("/supports","get")
            if(!res.err){
                dispatch(setSupportList(res?.data))
            } else {
                dispatch(setToast({ show: true, message: res?.msg || "Failed to load support tickets", severity: "error" }))
            }
        }catch(err){
            dispatch(setToast({ show: true, message: "Failed to load support tickets", severity: "error" }))
        }
    }
}

export default supportSlice.reducer